[
  {
    "code": "BQ-BO",
    "name": "Bonaire"
  },
  {
    "code": "BQ-SA",
    "name": "Saba"
  },
  {
    "code": "BQ-SE",
    "name": "Sint Eustatius"
  }
]